var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4048 50L35.2619 37.8571C33.8333 39.5238 32.6429 40.9524 31.4524 41.9048C29.5476 43.5714 28.119 43.5714 26.4524 43.5714L28.3571 36.4286C20.5 35.9524 13.5952 32.619 11.6905 28.3333C11.4524 29.5238 11.2143 30.4762 10.7381 31.1905C9.07143 34.0476 5.73809 34.0476 2.64286 34.0476C5.2619 34.0476 6.21429 30.2381 6.21429 25.7143C6.21429 21.1905 5.2619 17.381 2.64286 17.381C5.73809 17.381 9.07143 17.381 10.5 20.2381C10.9762 20.9524 11.2143 22.1429 11.4524 23.0952C12.1667 21.4286 13.8333 19.7619 15.9762 18.5714L0.5 3.09524L3.59524 0L50.5 46.9048L47.4048 50ZM21.2143 11.6667L19.3095 7.85714C24.0714 7.85714 28.8333 7.85714 31.9286 9.52381C34.5476 10.9524 36.2143 13.3333 37.6429 15.9524C44.5476 17.619 50.2619 21.4286 50.2619 25.7143C50.2619 28.8095 47.4048 31.6667 43.119 33.5714L21.2143 11.6667ZM35.9762 24.5238C35.9762 25.9524 36.9286 26.9048 38.3571 26.9048C39.7857 26.9048 40.7381 25.9524 40.7381 24.5238C40.7381 23.0952 39.7857 22.1429 38.3571 22.1429C36.9286 22.1429 35.9762 23.0952 35.9762 24.5238Z",
    fill: "#123660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.70e82eced13f76b5973f1a509bdb2b1d.svg";
export { ForwardRef as ReactComponent };